/* Somatine practice library - written sessions for the member area.
   Each practice: id, title, kind, state, minutes, summary, script[] */
window.SOM_PRACTICES = [

/* ─────────── WIRED — nervous system stuck in overdrive ─────────── */
{
  id:"w1", title:"The Physiological Sigh", kind:"Breathwork", state:"wired", minutes:2,
  summary:"The fastest way down from a spike. Two inhales, one long exhale. Use it in a car park, a bathroom, or at your desk.",
  script:[
    "Sit or stand. You don't need to close your eyes for this one - it works with them open.",
    "Breathe in through your nose until your lungs feel about three quarters full. [2s]",
    "Now, without breathing out, take a second short sniff in on top of it. Small. Just topping up. [2s]",
    "Let it go through your mouth. Slow. All the way to the bottom. Longer than felt necessary. [4s]",
    "That's one. Your body already knows this pattern - it's what you do when you've been crying, or after a shock. We're just doing it on purpose.",
    "Again. Long inhale through the nose. [3s] Short sniff on top. [2s] Long release through the mouth. [5s]",
    "Once more. [3s] Sniff. [2s] And out, slowly. [5s]",
    "Two more rounds at your own pace. Don't rush the exhale - that's the part doing the work. [20s]",
    "Now stop controlling it. Let your breath go back to whatever it wants to do. [10s]",
    "Notice whether anything dropped. Shoulders, maybe. The pace of your thinking. It won't feel dramatic. It isn't supposed to.",
    "That's the practice. Five rounds, any time you're climbing."
  ]
},
{
  id:"w2", title:"Box Breath for a Racing Mind", kind:"Breathwork", state:"wired", minutes:5,
  summary:"Four equal sides. Gives a spinning mind a shape to hold onto without asking it to stop.",
  script:[
    "Find a chair. Both feet on the floor, hands anywhere they're comfortable.",
    "We're going to breathe in a square. Four counts in, four held, four out, four held. If four is too long today, use three. This isn't an endurance test.",
    "Start by just breathing out everything you've got. [4s]",
    "In, two, three, four. [4s] Hold, two, three, four. [4s] Out, two, three, four. [4s] Hold, two, three, four. [4s]",
    "Again, and I'll go quiet for this one. [20s]",
    "Your mind will wander. That's not a failure - that's the whole exercise. You notice, you come back to the count. Noticing and returning is the rep.",
    "Keep going. In for four. [16s]",
    "If you lose the count, start again at one. Nobody's checking. [20s]",
    "Two more rounds. [20s]",
    "Now let the square dissolve. Breathe normally. [10s]",
    "Before you get up - is the thinking slower, or just quieter? Either counts."
  ]
},
{
  id:"w3", title:"Extended Exhale Reset", kind:"Breathwork", state:"wired", minutes:4,
  summary:"Make the out-breath longer than the in-breath. That ratio is what signals safety, not the depth of the breath.",
  script:[
    "Sit somewhere you can be still for four minutes. Uncross your legs if they're crossed.",
    "First, just watch your breath without changing it. Notice which is longer right now - in or out. [10s]",
    "When you're wired, the inhale usually wins. We're going to flip that.",
    "Breathe in through your nose for a count of four. [4s]",
    "Out through slightly pursed lips for six. Like you're cooling soup. [6s]",
    "In for four. [4s] Out for six. [6s]",
    "The out-breath is the signal. Longer out than in tells your body the emergency is over, whether or not your thoughts agree.",
    "Keep the rhythm. I'll stay quiet. [30s]",
    "If six feels strained, drop to four in, five out. Strain defeats the point. [20s]",
    "Continue. [30s]",
    "Last three rounds, and see if the exhale can get slower rather than longer. [20s]",
    "Let it go. Breathe however you like. [10s]",
    "You can do this one with your eyes open in a meeting and nobody will know."
  ]
},
{
  id:"w4", title:"Feet on the Floor", kind:"Somatic Reset", state:"wired", minutes:3,
  summary:"When your head is three hours into the future, this puts you back in the room you're actually in.",
  script:[
    "Wherever you are, put both feet flat on the ground. Shoes on is fine.",
    "Press down through your heels. Not hard. Just enough to feel the floor push back. [5s]",
    "Now press through the balls of your feet. [5s]",
    "Spread your toes inside your shoes, or let them spread if you're barefoot. [5s]",
    "Let the pressure go and just feel the weight of your legs. [8s]",
    "Name three things you can feel touching you. The chair. Your waistband. The air on your hands. Take your time. [15s]",
    "Now three things you can hear. Not judging them, just naming. [15s]",
    "Two things you can see without moving your head. [10s]",
    "Come back to your feet. Still there. Still on the floor. [8s]",
    "The point isn't calm. The point is location. You were somewhere else - a conversation you're dreading, a message you haven't sent. Now you're here.",
    "Stand up when you're ready."
  ]
},
{
  id:"w5", title:"Jaw, Shoulders, Hands", kind:"Somatic Reset", state:"wired", minutes:6,
  summary:"Three places women hold stress without noticing. We find each one, make it worse on purpose, then let it go.",
  script:[
    "Sit or lie down. Somewhere you won't be interrupted for six minutes.",
    "Start with your jaw. Don't fix it - just find it. Is it clenched? Are your back teeth touching? [8s]",
    "Now clench it deliberately. Hard. Hold. [5s]",
    "And release. Let your jaw hang slightly open. Tongue soft against the roof of your mouth. [10s]",
    "Notice the difference between clenched and released. That's the sensation you've been missing all day.",
    "Move to your shoulders. Where are they? Most people find them somewhere near their ears. [8s]",
    "Pull them up higher. Right up. Hold. [5s]",
    "Drop them. Let them fall further than feels normal. [10s]",
    "Again - up. [4s] And drop. [10s]",
    "Now your hands. Make fists. Tight enough that your forearms engage. [5s]",
    "Open them. Fingers wide, stretched. [5s]",
    "Let them rest, half curled, however they land. [10s]",
    "Scan all three. Jaw. Shoulders. Hands. [15s]",
    "One of them has already crept back. That's normal. Find it and let it go again. [10s]",
    "Do this once a day and you'll start catching the clench before it becomes a headache."
  ]
},
{
  id:"w6", title:"The Five-Minute Off-Ramp", kind:"Meditation", state:"wired", minutes:5,
  summary:"For the end of a day you can't stop replaying. A structured way out rather than white-knuckling it.",
  script:[
    "Sit down. This one works better sitting than lying - lying down too soon just moves the spinning into bed with you.",
    "Close your eyes if that's comfortable. If not, soften your gaze at a point on the floor.",
    "Three slow breaths to arrive. No counting, just slow. [15s]",
    "Now, deliberately, bring up the thing you keep replaying. Don't avoid it. [10s]",
    "Name it in one sentence. Silently. 'The conversation with my sister.' 'The email I sent too fast.' [10s]",
    "Now notice - where is it in your body? Chest, stomach, throat, jaw. Find where the thought lives physically. [15s]",
    "Put a hand there if you want to. [5s]",
    "Breathe into that spot. Not to remove it. Just to be there with it. [20s]",
    "Say to yourself: this is unfinished, and it will still be unfinished in the morning. [10s]",
    "Now widen out. Feel the whole of your body, not just that one spot. [15s]",
    "Feel the chair. The floor. The temperature of the room. [15s]",
    "Three more slow breaths. [20s]",
    "The thought hasn't gone. But you're no longer only the thought. That's the off-ramp.",
    "Open your eyes."
  ]
},
{
  id:"w7", title:"Cold Hands, Slow Breath", kind:"Somatic Reset", state:"wired", minutes:4,
  summary:"Uses cold water on the wrists and face to interrupt a spike physically. Good for panic that won't talk itself down.",
  script:[
    "This one needs a sink. Go to one now.",
    "Run the cold tap. Not freezing - just properly cold.",
    "Hold both wrists under the water. Inside of the wrist, where you'd take a pulse. [20s]",
    "Keep breathing while you do it. It's tempting to hold your breath against the cold. Don't. [15s]",
    "Now cup your hands and splash cold water on your face, twice. Focus on the area around your eyes and upper cheeks. [10s]",
    "Turn the tap off.",
    "Pat dry, or don't. Stand still for a moment. [10s]",
    "Now the breathing. In through the nose for four. [4s] Out through the mouth for eight. [8s]",
    "Again. In for four. [4s] Out for eight. [8s]",
    "Four more rounds, slowly. [40s]",
    "The cold on your face triggers a reflex that slows your heart. This isn't a metaphor - it's a physical circuit, and it works even when you're too far gone to reason with.",
    "One more round. [12s]",
    "Sit down for a minute before you go back to anything."
  ]
},

/* ─────────── DEPLETED — running on empty ─────────── */
{
  id:"d1", title:"Lying Down Body Scan", kind:"Meditation", state:"depleted", minutes:10,
  summary:"The classic, done properly. Not to relax you - to reconnect you to a body you've been ignoring.",
  script:[
    "Lie down. Bed, floor, sofa. Arms at your sides, palms up if that's comfortable.",
    "Let the surface hold you completely. You don't need to hold any part of yourself up. [15s]",
    "Three breaths, no effort. [15s]",
    "Bring your attention to your feet. Both of them. Not imagining them - actually feeling for sensation. Temperature, pressure, tingling, or nothing at all. Nothing at all is a valid finding. [20s]",
    "Move up to your calves and shins. [20s]",
    "Knees. [15s]",
    "Thighs. Notice their weight against the surface. [20s]",
    "Hips and pelvis. This is where a lot of women hold things they can't name. Just notice. [25s]",
    "Lower back. [20s]",
    "Belly. Let it be soft. Nobody's looking. [20s]",
    "Ribcage, rising and falling. [20s]",
    "Upper back and shoulders. [20s]",
    "Arms, all the way down to your fingertips. [20s]",
    "Neck and throat. [15s]",
    "Jaw, cheeks, the space around your eyes. [20s]",
    "The top of your head. [15s]",
    "Now the whole body at once. One thing, lying down, breathing. [30s]",
    "Stay here as long as you like. If you fall asleep, that was probably what you needed."
  ]
},
{
  id:"d2", title:"Legs Up the Wall", kind:"Somatic Reset", state:"depleted", minutes:8,
  summary:"One position, eight minutes, nothing to do. The most recovery available for the least effort.",
  script:[
    "Find a clear stretch of wall. Sit sideways next to it, hip touching the skirting board.",
    "Lie back and swing your legs up the wall as you turn. It'll feel awkward. It always does.",
    "Shuffle until your bottom is close to the wall - not touching necessarily, just close. Legs resting up, knees soft.",
    "Put a cushion under your head if you have one. Arms wide or on your belly.",
    "That's it. That's the whole position. [20s]",
    "Let your legs be completely passive. The wall is holding them. [20s]",
    "Breathe normally. We're not doing anything clever with the breath here. [30s]",
    "Your job for the next few minutes is to do nothing. That is genuinely harder than it sounds. [30s]",
    "If your mind starts listing tasks, let it. Don't fight it. The position is doing the work whether or not your mind cooperates. [40s]",
    "Notice your legs getting heavier. Or lighter. Or tingly. Whatever's happening. [40s]",
    "Stay here. I'll be quiet. [60s]",
    "Still here. [60s]",
    "When you're ready - no rush - bend your knees, roll to one side, and rest there for a moment before sitting up.",
    "Sit for a few breaths before standing. Standing up fast from this will make you dizzy."
  ]
},
{
  id:"d3", title:"Breathing Without Effort", kind:"Breathwork", state:"depleted", minutes:6,
  summary:"For days when even breathwork feels like another task. You don't control anything. You just watch.",
  script:[
    "Sit or lie however you actually want to. Not how you think you should.",
    "For the next six minutes you are not going to change your breathing at all. That's the rule.",
    "Just find it. Where do you notice it most? Nostrils, chest, belly? [15s]",
    "Whichever place is clearest, rest your attention there. [20s]",
    "Watch one breath in. [5s] And out. [5s]",
    "You'll want to deepen it or slow it. That's a habit. Let it stay exactly as shallow or as ragged as it is. [20s]",
    "Your breath doesn't need improving today. It's been working without your input your whole life. [20s]",
    "Keep watching. [30s]",
    "When you drift - and you will - come back to the place you chose. Nostrils, chest, or belly. [30s]",
    "There's no counting here, nothing to get right. [40s]",
    "Notice if the breath changed on its own. It usually does, once you stop managing it. [30s]",
    "A few more. [30s]",
    "That's the session. You didn't do anything, and something still shifted. Both things are true."
  ]
},
{
  id:"d4", title:"The Permission Practice", kind:"Meditation", state:"depleted", minutes:5,
  summary:"For when the exhaustion is guilt-shaped. Short, and deliberately not about pushing through.",
  script:[
    "Sit somewhere comfortable. This one is short.",
    "Two slow breaths. [10s]",
    "Bring to mind the thing you think you should be doing right now instead of this. [10s]",
    "There's probably more than one. Pick the loudest. [8s]",
    "Now say to yourself, silently: it can wait five minutes. [8s]",
    "Notice the resistance to that. There usually is some. [10s]",
    "Say it again: it can wait five minutes. And it can. Almost everything can. [10s]",
    "Breathe. [15s]",
    "Now a harder one. Say: I'm allowed to be this tired. [10s]",
    "Not 'I'll rest when this is finished.' Not 'other people manage.' Just - I'm allowed to be this tired. [15s]",
    "You've been treating exhaustion like a character flaw to fix. It's information. [15s]",
    "Two more breaths, and notice whether anything in your chest or throat loosened when you gave yourself permission. [20s]",
    "That loosening is the whole practice.",
    "Go slowly into whatever's next."
  ]
},
{
  id:"d5", title:"Two-Minute Recovery", kind:"Breathwork", state:"depleted", minutes:2,
  summary:"The smallest possible practice. For days when two minutes is honestly all there is.",
  script:[
    "Wherever you are. Standing is fine.",
    "Close your eyes or lower your gaze.",
    "Breathe in through your nose, slowly, and let your belly move rather than your chest. [5s]",
    "Out through your nose, slower. [7s]",
    "Again. In. [5s] Out, slower. [7s]",
    "Four more like that. Nothing else. [40s]",
    "Now drop your shoulders. [5s]",
    "Unclench your jaw. [5s]",
    "Two more breaths. [15s]",
    "That's it. That's the session. Two minutes counts. A practice you actually do beats a perfect one you skip."
  ]
},
{
  id:"d6", title:"Evening Wind-Down", kind:"Meditation", state:"depleted", minutes:12,
  summary:"A longer one for the end of a hard day. Designed to be done in bed, and to be fallen asleep in.",
  script:[
    "Get into bed. Lights low or off. Phone somewhere you can't reach without getting up.",
    "Lie on your back to start. You can turn over later.",
    "Let the mattress take your full weight. Most people are still slightly holding themselves. [20s]",
    "Three long breaths, exhale longer than the inhale. [25s]",
    "Now we're going to close the day deliberately, because it doesn't close itself.",
    "Think back to this morning. Not to judge it. Just to see it. [20s]",
    "Move through the day in rough order. Morning. [25s]",
    "Middle of the day. [25s]",
    "Evening, up to now. [25s]",
    "Somewhere in there was a moment that was fine. Not good necessarily. Just fine. Find it. [25s]",
    "Stay with that one for a moment. [20s]",
    "Now the unfinished things. Let them come up. [20s]",
    "For each one, silently: tomorrow. [15s]",
    "Again, anything else that surfaces: tomorrow. [20s]",
    "The day is closed. Not resolved - closed. Those are different, and only one of them is available tonight. [15s]",
    "Now let your attention rest on the weight of your body. [30s]",
    "Feel the warmth of the bed. [30s]",
    "Breathe. Nothing to do now. [40s]",
    "Turn over if you want to. Let it go from here. [30s]"
  ]
},

/* ─────────── REBUILDING — coming back, unevenly ─────────── */
{
  id:"r1", title:"Morning Orientation", kind:"Somatic Reset", state:"rebuilding", minutes:5,
  summary:"Done in the first ten minutes of waking. Sets the tone before the day sets it for you.",
  script:[
    "Do this before you look at your phone. That part matters more than the rest of it.",
    "Sit on the edge of the bed. Feet on the floor.",
    "Eyes open. Look slowly around the room, left to right. Don't move your head much - let your eyes do it. [15s]",
    "Now the other way. Right to left. Slowly. [15s]",
    "This tells your nervous system you're somewhere known and nothing is chasing you. It's a small thing and it works.",
    "Find one object in the room and rest your eyes on it. Anything. [15s]",
    "Notice its colour and edges without naming it in your head. [15s]",
    "Now take a breath in and, as you exhale, let your shoulders drop. [8s]",
    "Three more like that. [25s]",
    "Roll your shoulders backwards twice. [10s]",
    "Turn your head slowly to look over your left shoulder. [8s] Back to centre. [3s] Right shoulder. [8s] Centre. [3s]",
    "Now ask yourself one question, and answer honestly: what state am I actually in this morning? [15s]",
    "Not what you have to do. What state you're in. Wired, flat, steady, fragile. [15s]",
    "Whatever the answer is, that's what you plan today around. [10s]",
    "Stand up. Now you can get your phone."
  ]
},
{
  id:"r2", title:"Coherent Breathing", kind:"Breathwork", state:"rebuilding", minutes:6,
  summary:"Equal in, equal out, around five breaths a minute. The most researched pattern there is, and the most boring. Both are true.",
  script:[
    "Sit upright but not rigid. Back supported is fine.",
    "We're aiming for roughly five and a half seconds in, five and a half out. Don't get precious about the half.",
    "Breathe in through your nose. One, two, three, four, five. [5s]",
    "Out through your nose. One, two, three, four, five. [5s]",
    "In. [5s] Out. [5s]",
    "That's the whole pattern. No holds, no ratios. Just even.",
    "Keep going, and I'll count occasionally rather than constantly. [20s]",
    "In. [5s] Out. [5s] Keep the rhythm. [30s]",
    "If you're straining for five, use four. If four feels rushed, use six. The evenness matters more than the number. [30s]",
    "Continue. [40s]",
    "This is the one to build a habit around. It's unglamorous and it compounds. [40s]",
    "Two more minutes at your own pace. I'll be quiet. [60s]",
    "Still going. [50s]",
    "Now let it go. Breathe normally. [15s]",
    "Notice how your normal breath feels different after six minutes of even breathing. That difference is the point."
  ]
},
{
  id:"r3", title:"Noticing What's Different", kind:"Meditation", state:"rebuilding", minutes:7,
  summary:"Recovery is invisible from the inside. This is a structured way to see it.",
  script:[
    "Sit comfortably. Eyes closed or soft.",
    "Settle for a few breaths. [20s]",
    "We're going to look for evidence. Not to feel better - to be accurate.",
    "Think back to how you were three months ago. Not the events. The state. [20s]",
    "How were you sleeping then? [15s]",
    "How long did it take you to recover from something going wrong? [20s]",
    "What did your mornings feel like? [15s]",
    "Now today. Same questions. Sleep. [15s]",
    "Recovery time after something goes wrong. [20s]",
    "Mornings. [15s]",
    "Something in there is different. It might be small. It might be one of three. Find the one that's changed. [25s]",
    "Stay with it. Let yourself actually register it rather than moving straight past. [20s]",
    "Here's the part that matters: you did that. Not a good week. Not luck. Repetition. [20s]",
    "Now notice the voice that wants to say 'yes but' - and let it be there without following it. [20s]",
    "Two more breaths. [15s]",
    "Do this one every few weeks. Progress you can't see is progress you'll quit on."
  ]
},
{
  id:"r4", title:"Gentle Activation", kind:"Somatic Reset", state:"rebuilding", minutes:5,
  summary:"For flat, heavy days when rest hasn't helped. Raises energy without tipping into wired.",
  script:[
    "Stand up. You need a bit of space for this one - arm's length is enough.",
    "Feet hip width apart. Knees soft, not locked.",
    "Start by shaking out your hands. Loose wrists, like you're flicking water off. [15s]",
    "Add your forearms. [10s]",
    "Now let it travel - shoulders, then the whole upper body. Keep it loose and a bit ridiculous. [20s]",
    "Bounce gently through your knees while you do it. [20s]",
    "Stop. Stand still. Arms by your sides. [15s]",
    "Feel what's happening. Tingling, warmth, heart rate slightly up. That's the point - we're raising energy, not calming down. [15s]",
    "Now three big breaths. In through the nose, out through the mouth with a sigh you can hear. [20s]",
    "Roll your shoulders back five times, slowly. [20s]",
    "Reach both arms overhead and stretch tall. [10s]",
    "Let them fall. [8s]",
    "One more round of shaking, shorter this time. [15s]",
    "Stand still again. [15s]",
    "Flat days don't always need more rest. Sometimes they need movement small enough that you'll actually do it."
  ]
},
{
  id:"r5", title:"The Restart Practice", kind:"Meditation", state:"rebuilding", minutes:4,
  summary:"For the day you come back after missing a week. The most important session in the library.",
  script:[
    "Sit down. You're here, which is the hard part done.",
    "Two breaths. [12s]",
    "You missed some days. Maybe a lot of days. We're going to deal with that now rather than carrying it.",
    "Notice what you've been telling yourself about the gap. [15s]",
    "It's usually some version of: this is proof I don't stick at things. [12s]",
    "Here's the correction, and it's not a pep talk - it's how the physiology works. Regulation isn't a streak. It's a total. Every session counts toward the total whether or not it was consecutive. [20s]",
    "The gap didn't erase what came before it. [15s]",
    "Breathe. [15s]",
    "Now, quietly, drop the plan you had before. The one you fell off. It was probably too ambitious. [15s]",
    "Choose one thing for tomorrow. One session. The shortest one if necessary. [15s]",
    "Say it to yourself specifically. Which practice, roughly what time. [15s]",
    "That's all you're committing to. Not the week. Tomorrow. [12s]",
    "Two more breaths, and go. [15s]",
    "Come back to this one every time you fall off. It's not a failure practice. It's part of the method."
  ]
},
{
  id:"r6", title:"Building Tolerance", kind:"Breathwork", state:"rebuilding", minutes:8,
  summary:"Slightly harder breathwork. For when the short practices have got easy and you're ready for capacity.",
  script:[
    "Sit upright, spine long. This one asks a bit more of you.",
    "Start with two minutes of even breathing to settle. Five in, five out. [45s]",
    "Keep going. [45s]",
    "Now we lengthen the exhale. In for four. [4s] Out for eight. [8s]",
    "Again. In for four. [4s] Out for eight. [8s]",
    "Six rounds. If you run out of air before eight, shorten to six and build up over weeks. [50s]",
    "Keep going. [45s]",
    "Now a pause. Breathe out fully, and rest at the bottom for a count of three before breathing in. [10s]",
    "In for four. [4s] Out for six. [6s] Pause at the bottom, two, three. [3s]",
    "Again. [15s]",
    "That pause is where tolerance builds. A small, safe amount of discomfort, on purpose, in a situation you control. [15s]",
    "Four more rounds. Stop if you feel lightheaded - that's the signal to go gentler, not to push. [50s]",
    "Continue. [45s]",
    "Now let it all go. Breathe entirely normally for a minute. [50s]",
    "Notice you're steadier than when you started, despite the work being harder. That's capacity."
  ]
},

/* ─────────── STEADY — maintaining what you've built ─────────── */
{
  id:"s1", title:"Daily Check-In", kind:"Meditation", state:"steady", minutes:3,
  summary:"The maintenance dose. Three minutes, same time each day, no agenda.",
  script:[
    "Sit. Same chair each day if you can - the repetition helps.",
    "Close your eyes. [5s]",
    "One long breath in, one long breath out. [12s]",
    "Ask: how am I, actually? [15s]",
    "Wait for the answer rather than producing one. [15s]",
    "Whatever it is, don't fix it. Just register it. [15s]",
    "Now scan quickly - jaw, shoulders, belly. [20s]",
    "Anything holding, let it go. [15s]",
    "One more question: what does today need from me, and what do I need from today? [20s]",
    "Don't plan. Just let the answer sit there. [20s]",
    "Three breaths, and finish. [20s]",
    "That's it. Three minutes, daily, is worth more than an hour on Sunday."
  ]
},
{
  id:"s2", title:"Sustaining Breath", kind:"Breathwork", state:"steady", minutes:5,
  summary:"A steady-state pattern for people who aren't in crisis and want to stay that way.",
  script:[
    "Sit upright, comfortable.",
    "Settle with a few natural breaths. [15s]",
    "In for five. [5s] Out for five. [5s]",
    "Continue at that pace, and let it become automatic rather than counted. [30s]",
    "Keep going. [40s]",
    "Now add a small thing: on each exhale, let one part of your body soften. Choose a different one each time. [15s]",
    "Exhale, soften the jaw. [8s]",
    "Exhale, soften the shoulders. [8s]",
    "Exhale, soften the hands. [8s]",
    "Exhale, soften the belly. [8s]",
    "Keep going through the body in your own order. [40s]",
    "Continue. [40s]",
    "Last minute. Let the counting go and just breathe evenly. [50s]",
    "Finish when you're ready. This is the one to do on ordinary days - the ones where nothing is wrong. Those are the days that build the buffer."
  ]
},
{
  id:"s3", title:"Midday Reset", kind:"Somatic Reset", state:"steady", minutes:4,
  summary:"A break that actually breaks. Four minutes at the point in the day where things usually start slipping.",
  script:[
    "Stand up from wherever you've been sitting. Step away from the screen.",
    "Roll your shoulders backwards, five times. [15s]",
    "Turn your head slowly left. [8s] Centre. [3s] Right. [8s] Centre. [3s]",
    "Now look at something far away. Out a window if there is one, down a corridor if not. Let your eyes focus on distance. [20s]",
    "Your eyes have been at arm's length for hours. This is a genuine physical reset, not just a metaphor.",
    "Keep looking into the distance. Blink properly. [20s]",
    "Now three breaths, in through the nose, out through the mouth. [20s]",
    "Reach your arms overhead and stretch. [10s]",
    "Fold forward loosely, knees bent, let your head hang. [15s]",
    "Roll up slowly. [10s]",
    "Two more breaths. [12s]",
    "Notice the afternoon usually goes differently when you take this than when you push through. Test it for a week."
  ]
},
{
  id:"s4", title:"Gratitude Without Forcing", kind:"Meditation", state:"steady", minutes:6,
  summary:"Gratitude practice for people who find gratitude practice irritating. No forced positivity.",
  script:[
    "Sit comfortably. Eyes closed or soft.",
    "Settle. [20s]",
    "We're not going to list things you should be grateful for. That version makes most people feel worse.",
    "Instead: think of one specific moment from the last two days that was slightly better than neutral. [25s]",
    "Small is fine. The first sip of coffee. A door held open. Ten quiet minutes. [20s]",
    "Got one? Stay with it. [15s]",
    "Now put yourself back in it physically. Where were you? What could you see? [25s]",
    "What did your body feel like in that moment? [25s]",
    "That's the part that matters - the physical trace, not the sentiment. [15s]",
    "Stay there. [30s]",
    "Now find a second one. Different day if possible. [25s]",
    "Same thing. Where, what you saw, what your body felt. [35s]",
    "Rest there. [25s]",
    "Two breaths, and finish. [15s]",
    "You're not manufacturing feeling. You're training attention toward evidence it usually skips."
  ]
},
{
  id:"s5", title:"Pre-Sleep Settle", kind:"Meditation", state:"steady", minutes:9,
  summary:"A shorter, gentler wind-down for nights that aren't hard - just ordinary.",
  script:[
    "In bed, lights off. Lie however you normally sleep.",
    "Let the bed hold you. [20s]",
    "Breathe out longer than you breathe in. Don't count - just let the exhale be the long one. [30s]",
    "Continue. [40s]",
    "Now bring your attention to your feet, and slowly move it upward. Feet. [20s]",
    "Legs. [25s]",
    "Hips and lower back. [25s]",
    "Belly and chest. [25s]",
    "Arms and hands. [25s]",
    "Shoulders and neck. [25s]",
    "Face. Let it be completely slack. [25s]",
    "Whole body. [30s]",
    "If thoughts about tomorrow arrive, that's fine. Let them pass through without picking any of them up. [40s]",
    "Back to the breath. Long exhale. [40s]",
    "Nothing more to do tonight. [40s]",
    "Let it go from here. [40s]"
  ]
},
{
  id:"s6", title:"The Weekly Review", kind:"Meditation", state:"steady", minutes:10,
  summary:"Once a week, ideally the same day. Keeps the practice honest and stops it becoming autopilot.",
  script:[
    "Sit somewhere you can think clearly. Have a notebook nearby if you like - you may want it at the end.",
    "Settle with a minute of even breathing. [45s]",
    "Continue. [30s]",
    "Now, the week. Move through it without judging. Monday. [20s]",
    "Midweek. [25s]",
    "The end of the week. [25s]",
    "First question: which day was hardest, and what was actually happening in your body that day? [30s]",
    "Not what went wrong externally. What state you were in. [25s]",
    "Second question: did you practise that day? [20s]",
    "No guilt either way - we're gathering data, not marking homework. [15s]",
    "Third: which practice did you reach for most this week? [25s]",
    "And did it work? Honestly? [25s]",
    "Fourth: what's coming next week that you already know will be demanding? [30s]",
    "Choose now which practice you'll use for it, and when. [30s]",
    "Be specific. Vague intentions don't survive a hard Tuesday. [20s]",
    "Last one: what's one thing you'll drop from the plan because it isn't working? [30s]",
    "Dropping something is not quitting. A plan you keep pruning is a plan you keep. [20s]",
    "Two breaths, and open your eyes. Write down the two decisions before you forget them. [20s]"
  ]
}
];

/* 7-day plans, keyed to the quiz result letters (A/B/C/D) */
window.SOM_PLANS = {
  A: { name:"The Warrior", focus:"Coming down from constant alert",
       intro:"You're running hot. The plan front-loads the fastest down-regulators, then builds an evening close so the day actually ends.",
       days:[
         {d:1, id:"w1", note:"Start with the shortest thing that works. Do it three separate times today."},
         {d:2, id:"w3", note:"Longer exhale. Notice which is longer for you at rest - that's your baseline."},
         {d:3, id:"w5", note:"Find out where you've been holding it. Most people are surprised by the jaw."},
         {d:4, id:"w2", note:"Give the racing mind a shape. Expect to lose count - that's the rep."},
         {d:5, id:"w6", note:"An off-ramp for the evening replay. Sitting, not lying."},
         {d:6, id:"w4", note:"Three minutes. Use it the moment you notice you're somewhere else."},
         {d:7, id:"d6", note:"Close the week properly. In bed, phone out of reach."}
       ]},
  B: { name:"The Carrier", focus:"Putting something down before you can rest",
       intro:"You've been holding more than your share. This week is about permission and recovery, not discipline.",
       days:[
         {d:1, id:"d4", note:"Start here. The guilt is the thing in the way, so we deal with it first."},
         {d:2, id:"d2", note:"Eight minutes doing nothing. Harder than it sounds."},
         {d:3, id:"d1", note:"Reconnect to a body you've been running on without checking."},
         {d:4, id:"d5", note:"A deliberately tiny day. Two minutes counts."},
         {d:5, id:"d3", note:"No controlling the breath at all today. Just watching."},
         {d:6, id:"w5", note:"Find the physical holding. Carriers usually hold in the shoulders."},
         {d:7, id:"d6", note:"Close the day and the week. Let yourself fall asleep in it."}
       ]},
  C: { name:"The Rebuilder", focus:"Making the progress visible and repeatable",
       intro:"You're further along than it feels. This week builds rhythm and gives you evidence you're actually moving.",
       days:[
         {d:1, id:"r1", note:"Before your phone. That part is the practice."},
         {d:2, id:"r2", note:"The unglamorous one that compounds. Start the habit here."},
         {d:3, id:"r4", note:"For the flat day that's probably coming mid-week."},
         {d:4, id:"r3", note:"Look for evidence. Be accurate rather than positive."},
         {d:5, id:"r2", note:"Again. Repetition is the mechanism - novelty isn't."},
         {d:6, id:"r6", note:"Slightly harder. Stop if you're lightheaded."},
         {d:7, id:"s6", note:"Review the week and choose what to drop."}
       ]},
  D: { name:"The Steady One", focus:"Protecting the buffer you've built",
       intro:"Nothing's wrong, and that's exactly when practice slips. This week is maintenance and a stress-test.",
       days:[
         {d:1, id:"s1", note:"Three minutes. Same chair, same time, every day this week if you can."},
         {d:2, id:"s2", note:"Steady-state breathing on an ordinary day. Ordinary days build the buffer."},
         {d:3, id:"s3", note:"Take the break properly. Test whether the afternoon goes differently."},
         {d:4, id:"s1", note:"Again. The check-in is the backbone - everything else is optional."},
         {d:5, id:"s4", note:"Attention training, not forced positivity."},
         {d:6, id:"r6", note:"A harder session to keep capacity growing rather than plateauing."},
         {d:7, id:"s6", note:"The weekly review. Prune what isn't working."}
       ]}
};


/* Public-domain audio archive - 'The Hindu-Yogi Science of Breath' (1904),
   read for LibriVox. Public domain, hosted on our own CDN. */
window.SOM_AUDIO = [
 {
  "id": "a1",
  "title": "The Nervous System",
  "minutes": 6,
  "seconds": 44,
  "note": "Groundwork on why breathing reaches the nervous system at all.",
  "url": "https://cdn.shopify.com/s/files/1/0745/5070/6327/files/hinduyogiscienceofbreath_05_atkinson_64kb.mp3?v=1788918157"
 },
 {
  "id": "a2",
  "title": "Nostril vs Mouth Breathing",
  "minutes": 8,
  "seconds": 4,
  "note": "Why nasal breathing is the default worth returning to.",
  "url": "https://cdn.shopify.com/s/files/1/0745/5070/6327/files/hinduyogiscienceofbreath_06_atkinson_64kb.mp3?v=1788918157"
 },
 {
  "id": "a3",
  "title": "The Four Methods of Respiration",
  "minutes": 11,
  "seconds": 52,
  "note": "The four breathing patterns, and which one most adults default to.",
  "url": "https://cdn.shopify.com/s/files/1/0745/5070/6327/files/hinduyogiscienceofbreath_07_atkinson_64kb.mp3?v=1788918158"
 },
 {
  "id": "a4",
  "title": "How to Acquire the Complete Breath",
  "minutes": 5,
  "seconds": 47,
  "note": "The core instructional chapter. Start here if you only listen to one.",
  "url": "https://cdn.shopify.com/s/files/1/0745/5070/6327/files/hinduyogiscienceofbreath_08_atkinson_64kb.mp3?v=1788918157"
 },
 {
  "id": "a5",
  "title": "Seven Developing Exercises",
  "minutes": 9,
  "seconds": 53,
  "note": "A sequence of seven breathing exercises, described step by step.",
  "url": "https://cdn.shopify.com/s/files/1/0745/5070/6327/files/hinduyogiscienceofbreath_11_atkinson_64kb.mp3?v=1788918157"
 },
 {
  "id": "a6",
  "title": "Seven Minor Exercises",
  "minutes": 5,
  "seconds": 48,
  "note": "Shorter variations to use between the longer sequences.",
  "url": "https://cdn.shopify.com/s/files/1/0745/5070/6327/files/hinduyogiscienceofbreath_12_atkinson_64kb.mp3?v=1788918157"
 },
 {
  "id": "a7",
  "title": "Rhythmic Breathing",
  "minutes": 8,
  "seconds": 53,
  "note": "Pacing the breath to a steady internal count.",
  "url": "https://cdn.shopify.com/s/files/1/0745/5070/6327/files/hinduyogiscienceofbreath_13_atkinson_64kb.mp3?v=1788918158"
 }
];
